import React from 'react'
import { Box, Button, Flex, Heading, Message, Modal, Text } from '@workwhile/ui'
import { useRemoveQuestionFlowContextValue } from '../context/RemoveQuestionFlowProvider'
import { useRequirementDetailWorkflowsContextValue } from '../../../context/RequirementDetailWorkflowProvider'

export const RemoveQuestionFlowMain = () => {
  const {
    removeQuestionFlow: { isOpen, close },
  } = useRequirementDetailWorkflowsContextValue()

  const {
    state: { question, isPending, errorMessage },
    actions: { confirm },
  } = useRemoveQuestionFlowContextValue()

  return (
    <Modal
      open={isOpen}
      onClose={close}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm}>
            Remove
          </Button>
        </Flex>
      }
    >
      <Heading level={2} m={0}>
        Remove question
      </Heading>
      <Text mt={3} fontSize={3}>
        Are you sure you want to remove this question from the requirement?
      </Text>

      <Flex mt={3} flexDirection="column" gap={3}>
        <Box>
          <Text fontWeight="bold">Question ({question.id})</Text>
          <Text>"{question.question}"</Text>
        </Box>
      </Flex>

      <Flex mt={3} flexDirection="column" gap={3}>
        <Box as="ul" m={0} pl={3} style={{ listStyleType: 'disc' }}>
          <Box as="li" color="lightText" fontSize={1}>
            New assessments won't include this question, but past failures for
            only the deleted question will now be considered a pass.
          </Box>
          <Box as="li" color="lightText" fontSize={1}>
            Ensure this requirement still has at least one question after
            removing this one.
          </Box>
        </Box>
      </Flex>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
